import React from "react";
import { LaunchableErrorLayout } from "./LaunchableErrorLayout";

export const LaunchableNotFound: React.FC = () => (
  <LaunchableErrorLayout
    title="Launchable Not Found"
    description="Either the launchable id does not exist or was deleted."
  />
);
